/* eslint-disable no-use-before-define */

import api from '@utils/api'

import { cleanStorageAuth, setAuthAdmin } from '@utils/general'

export const login = ({ email, password }) => async (dispatch, _getState) => {
  const data = {
    username: email,
    password
  }
  const response = await api.loginAuth(data)
  if (!response?.status) {
    await setAuthAdmin(response.data)
  }
  return response;
};

export const getUserInfo = () => async (dispatch, _getState) => {
  const response = await api.getUserInfoAuth()
  if (!response?.status) {
    await setAuthAdmin(response.data)
  } else {
    cleanStorageAuth()
  }
  return response;
};

export const forgotPassword  = ({ email }) => async (_dispatch, _getState) => {
  const data = {
    username: email
  }
  const response = await api.forgotPassword(data)
  return response;
};

export const validateToken  = ({ email, secureCode }) => async (_dispatch, _getState) => {
  const data = {
    email,
    token: secureCode,
    operation: "ResetPassword"
  }
  const response = await api.validateToken(data)
  return response;
};

export const resetPassword  = ({ email, confirmPassword }) => async (_dispatch, _getState) => {
  const data = {
    email,
    newPassword: confirmPassword,
  }
  const response = await api.resetPassword(data)
  return response;
};
